export default function NotFoundPage() {
  return (
    <div style={{
      display: "flex",
      flexDirection: "column",
      alignItems: "center",
      justifyContent: "center",
      minHeight: "100vh",
      padding: "20px",
      fontFamily: "system-ui, sans-serif"
    }}>
      <h1 style={{ fontSize: "48px", marginBottom: "16px" }}>404</h1>
      <p style={{ color: "#666", marginBottom: "24px" }}>页面不存在</p>
      <a href="/" style={{
        padding: "10px 20px",
        background: "#6366f1",
        color: "white",
        borderRadius: "8px",
        textDecoration: "none"
      }}>返回首页</a>
    </div>
  )
}